<template>
  <div class="body rtls">
    <div class="gray-bg">
      <div class="middle-box text-center loginscreen animated fadeInDown">
        <h3>
          درصورتی که دانلود شما به صورت خودکار صورت نگرفت روی لینک زیر کلیک
          نمایید
        </h3>
        <a @click="downloadLink">دانلود</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.$setLayout("simple-layout");
    var _this = this;
    _this.$nextTick(() => {
      _this.downloadLink();
    });
  },
  methods: {
    downloadLink(e) {
      if (e) e.preventDefault();
      window.open("http://bar.bitaidea.ir/downloads/android", "Download");
    },
  },
};
</script>
<style scoped>
.gray-bg {
  height: 100vh;
  background: #ccc !important;
}
.middle-box {
  width: 70% !important;
}
</style>